




























































import NoticeIcon from "./noticeIcon.vue";
import { message } from "ant-design-vue";
import { IUserLoginInfoModel } from "@/model";
import { UserService } from "src/services";
import { Vue, Prop, Component } from "vue-property-decorator";

@Component({
  components: {
    NoticeIcon,
  },
})
export default class UserMenu extends Vue {
  /**
   * 当前表单
   */
  public get $form(): any {
    return this.$refs["form"];
  }

  /**
   * 模式
   * @protected
   * @type {string}
   */
  @Prop({ type: String, default: "sidemenu" })
  protected mode: string;

  /**
   * labelCol
   * @protected
   * @type {any}
   */
  protected labelCol: any = {
    xs: { span: 24 },
    sm: { span: 5 },
  };

  /**
   * wrapperCol
   * @protected
   * @type {any}
   */
  protected wrapperCol: any = {
    xs: { span: 24 },
    sm: { span: 16 },
  };

  /**
   * 是否可见
   * @protected
   * @type {boolean}
   */
  protected visible: boolean = false;

  /**
   * confirmLoading
   * @protected
   * @type {boolean}
   */
  protected confirmLoading: boolean = false;

  /**
   * 默认app
   * @protected
   * @type {any}
   */
  protected defApp: Array<any> = [];

  /**
   * 用户服务实例
   * @private
   * @return UserService
   */
  private _userService: UserService;

  /**
   * 获取或设置用户实例。
   * @protected
   * @returns UserService
   */
  protected get userService(): UserService {
    if (!this._userService) {
      this._userService = this.$serviceProvier.resolve<UserService>(
        UserService
      );
    }

    return this._userService;
  }

  /**
   * 用户信息
   * @protected
   * @type {any}
   */
  protected get userInfo(): IUserLoginInfoModel {
    return JSON.parse(localStorage.getItem("profile")) as IUserLoginInfoModel;
  }

  /**
   * 昵称
   * @protected
   * @type {string}
   */
  protected nickname: string = this.userInfo.nickName || this.userInfo.name;

  /**
   * 头像
   * @protected
   * @type {string}
   */
  protected avatar: string = this.userInfo.avatar;

  /**
   * 注销登录
   * @protected
   * @return void
   */
  protected handleLogout(): void {
    this.$confirm({
      title: "提示",
      content: "是否确定注销登录?",
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        return await this.logout()
          .then(() => {
            setTimeout(() => {
              localStorage.clear();
              this.$router.push("/")
            }, 20);
          })
          .catch(() => {
            this.$message.error("注销失败");
          });
      },
      onCancel() {},
    });
  }

  /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

  /**
   * 打开切换应用框
   * @protected
   * @return void
   */
  protected appToggled(): void {
    this.visible = true;
    let appStorage = JSON.parse(localStorage.getItem("app_menu") || "[]");
    appStorage && this.defApp.push(appStorage[0].code);
  }

  /**
   * 切换应用
   * @protected
   * @return void
   */
  protected async switchApp(appId: number): Promise<void> {
    this.visible = false;
    this.defApp = [];
    const applicationData = this.userInfo.apps.filter(
      (item) => item.id === appId
    );
    if (!applicationData || applicationData.length === 0) {
      message.error("应用切换异常");
    }

    const hideMessage = message.loading("正在切换应用！", 0);
    let defaultApp = applicationData[0];

    // 调用菜单切换接口
    this.$store
      .dispatch("global/menuChange", defaultApp)
      .then(() => {
        hideMessage();
      })
      .catch((err: any) => {
        message.error("应用切换异常");
      });
  }

  /**
   * 处理取消操作
   * @protected
   * @return void
   */
  protected handleCancel(): void {
    this.$form.resetFields();
    this.visible = false;
  }
}
